"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBulkEditAffectedProductsCount = void 0;
const react_1 = require("react");
const bulk_edit_attributes_dialog_constants_1 = require("../bulk-edit-product-attributes-dialog/bulk-edit-attributes-dialog.constants");
const use_get_products_total_count_by_filter_hook_1 = require("../../../client/product/hooks/use-get-products-total-count-by-filter.hook");
const use_product_tree_node_hook_1 = require("../../../client/product-tree-node/hooks/use-product-tree-node.hook");
const attributes_1 = require("../../../constants/attributes");
const store_1 = require("../../../../store");
const useBulkEditAffectedProductsCount = ({ selectedTreeNodeId, selectedAttributeId, selectedValues, operationType, productsFilter, selectedProductsCount, }) => {
    var _a;
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const { data: selectedTreeNode } = (0, use_product_tree_node_hook_1.useProductTreeNode)({ id: selectedTreeNodeId });
    const isTerminalNode = (_a = selectedTreeNode === null || selectedTreeNode === void 0 ? void 0 : selectedTreeNode.isTerminalNode) !== null && _a !== void 0 ? _a : false;
    const shouldUseOutOfStrategyFilter = !isTerminalNode && !!selectedAttributeId;
    const isDeleteMode = operationType === bulk_edit_attributes_dialog_constants_1.BulkEditOperationTypes.Delete;
    const isWipeAllValuesMode = isDeleteMode && !selectedValues.length;
    // N/A is a system-level value that should be valid for all attribute-node pairs.
    // Exclude it from strategy value filtering to avoid false "out of strategy" blocks (EN-5469).
    const strategyValues = (0, react_1.useMemo)(() => selectedValues.filter((v) => v !== attributes_1.SpecialAttributeValue.NotApplicable), [selectedValues]);
    const nodeStrategyAttributes = (0, react_1.useMemo)(() => {
        if (!shouldUseOutOfStrategyFilter) {
            return undefined;
        }
        if (isWipeAllValuesMode || strategyValues.length === 0) {
            return [{ label: selectedAttributeId }];
        }
        return [{ label: selectedAttributeId, values: strategyValues }];
    }, [isWipeAllValuesMode, selectedAttributeId, strategyValues, shouldUseOutOfStrategyFilter]);
    const shouldRunAffectedCountQuery = shouldUseOutOfStrategyFilter && (isDeleteMode || selectedValues.length > 0);
    const affectedCountFilter = (0, react_1.useMemo)(() => ({
        product: productsFilter.product,
        nodeStrategyAttributes,
        presentationAttributes: productsFilter.presentationAttributes,
        presentationAttributeFilterStrategy: productsFilter.presentationAttributeFilterStrategy,
        isReviewed: productsFilter.isReviewed,
    }), [nodeStrategyAttributes, productsFilter]);
    const { fetchProductsTotalCount, totalCount: affectedProductsCount, isLoading: isAffectedProductsCountLoading, } = (0, use_get_products_total_count_by_filter_hook_1.useGetProductsTotalCountByFilter)({
        catalogId: selectedCatalogId,
        productTreeNodeId: selectedTreeNodeId,
        filter: affectedCountFilter,
        options: {
            skip: !shouldRunAffectedCountQuery,
        },
    });
    const skippedProductsCount = Math.max(selectedProductsCount - affectedProductsCount, 0);
    const isAffectedCountBusy = shouldRunAffectedCountQuery && isAffectedProductsCountLoading;
    return {
        triggerAffectedCountQuery: fetchProductsTotalCount,
        shouldUseOutOfStrategyFilter,
        shouldRunAffectedCountQuery,
        isAffectedCountBusy,
        shouldShowAffectedProductsBanner: shouldRunAffectedCountQuery && !isAffectedCountBusy,
        affectedProductsCount,
        skippedProductsCount,
        nodeStrategyAttributes,
    };
};
exports.useBulkEditAffectedProductsCount = useBulkEditAffectedProductsCount;
